/** Schritt 4 „Kandidatenliste“ und Drawer „Talent-Vorschau“. */
const wizCandidatesListDE = {
  wizListOverview: 'Kandidaten-Übersicht',
  wizListFilterAll: 'Alle Kandidaten',
  wizListFilterOther: 'Kandidaten anderer Kampagnen',
  wizListFilterSex: 'Unklares Geschlecht',
  wizListFilterBlocked: 'Blockierte Kandidaten',
  wizListHeadline: '{{active}} von {{total}} Kandidaten auf der finalen Kandidatenliste',
  wizListProgress:
    'Erste Vorschau aus der Suche · weitere ca. {{amount}} Profile bewertet SAIA nach dem Start laufend',
  wizListJudgeLabel: 'KI-Urteil:',
  wizListJudgeA: 'Muss erfüllt',
  wizListJudgeB: 'Muss nicht belegt',
  wizListJudgeC: 'Ausschluss',
  wizListRatingFailed: 'Fehlgeschlagen',
  wizListRatingFailedHint: 'Die Bewertung ist fehlgeschlagen.',
  wizListRatingAnalysing: 'Wird analysiert',
  wizListRatingAnalysingHint: 'Das Profil wird zuerst analysiert, danach folgt die Bewertung.',
  wizListRatingLinkedin: 'Wartet (LinkedIn-Limit)',
  wizListRatingLinkedinHint:
    'Die Profilanalyse ist pausiert, weil LinkedIn die Profilaufrufe dieses Kontos vorübergehend begrenzt hat. SAIA analysiert automatisch weiter.',
  wizListAnalysisPause:
    'Profilanalyse pausiert.',
  wizListPauseLead:
    'Profilanalyse pausiert: LinkedIn hat die Profilaufrufe dieses Kontos vorübergehend begrenzt.',
  wizListPauseResumes: 'SAIA analysiert die restlichen Kandidaten automatisch weiter (voraussichtlich ab {{date}}).',
  wizListPauseResumesAuto: 'SAIA analysiert die restlichen Kandidaten automatisch weiter.',
  wizListPauseReducedHalf: 'Zum Schutz des Kontos ruft SAIA bis {{date}} nur halb so viele Profile pro Tag ab.',
  wizListPauseReduced: 'Zum Schutz des Kontos ruft SAIA bis {{date}} weniger Profile pro Tag ab.',
  wizListRatingQuota: 'Wartet (Kontingent)',
  wizListRatingQuotaHint:
    'Wartet auf Analyse: Das Tageskontingent für Profilanalysen ist erschöpft. Die Analyse wird fortgesetzt, sobald wieder Kontingent frei ist – automatisch oder über „Erneut bewerten“.',
  wizDrawerRejudgeError: 'Die Bewertung konnte nicht neu gestartet werden.',
  wizDrawerRejudge: 'Erneut bewerten',
  wizListJudgePending: 'Wird bewertet',
  wizListColActive: 'Aktiv',
  wizListColName: 'Name',
  wizListColJudge: 'KI-Urteil',
  wizListColCompany: 'Unternehmen',
  wizListColTitle: 'Jobtitel',
  wizListSources: 'Herkunft',
  wizListSourceName: 'Link {{n}} · {{kind}}',
  wizListSourceSkipped: 'übersprungen – findet niemanden',
  wizListSourceFailed: 'Suche fehlgeschlagen',
  wizListSourceFix: 'Korrigieren',
  wizListSourceLoaded: '{{loaded}} von {{total}}',
  wizListSourceLoadedOnly: '{{loaded}} geladen',
  wizListColSource: 'Link',
  wizListSourceShort: 'L{{n}}',
  wizListColLocation: 'Ort',
  wizListOtherCampaign: 'In anderer Kampagne',
  wizListUnclearSex: 'Unklares Geschlecht',
  wizListMoreAfterStart: 'Sobald die Kampagne läuft, lädt SAIA automatisch weitere Kontakte nach.',
  wizListMoreAvailable: 'Bei LinkedIn warten noch ca. {{count}} weitere Profile.',
  wizListLoadMore: 'Nächste 50 laden',
  wizListLoadMoreBusy: 'Wird geladen …',
  wizListUnclearSexSet: 'Klicken, um das Geschlecht festzulegen',
  wizListSexTitle: 'Geschlecht festlegen',
  wizListSexBody: 'Das Geschlecht ließ sich nicht sicher erkennen. Sieh im LinkedIn-Profil nach und lege es fest – danach wird der Kandidat wieder nach seiner Bewertung angesprochen.',
  wizListSexFemale: 'Weiblich',
  wizListSexMale: 'Männlich',
  wizListSexCancel: 'Abbrechen',
  wizListSexSave: 'Speichern',
  wizListBlacklist: 'Blacklist',
  wizListEmpty: 'Keine Kandidaten in dieser Ansicht.',
  wizListLoading: 'Kandidaten werden geladen …',
  wizListAnalysing:
    'Bei {{amount}} Kandidaten wird das Profil zuerst analysiert, danach folgt die Bewertung.',
  wizListAnalysisQuota:
    'Das Tageskontingent für Profilanalysen ist erschöpft. Die Analyse wird fortgesetzt, sobald wieder Kontingent frei ist.',
  wizListImporting: 'SAIA lädt und bewertet die ersten Kandidaten aus der Suche …',
  wizListLoadError: 'Die Kandidaten konnten nicht geladen werden.',
  wizListActionError: 'Die Änderung konnte nicht gespeichert werden.',
  wizListOpen: 'Kandidat ansehen',
  wizListToggleActive: 'Aktiv schalten',
  wizDrawerProfileLink: 'LinkedIn-Profil öffnen',
  wizListMinutes: '{{minutes}} Min.',
  wizListHours: '{{hours}} Std.',
  wizListHoursMinutes: '{{hours}} Std. {{minutes}} Min.',
  wizListForecastAll:
    'Analyse läuft: noch ca. {{minutes}} für {{count}} Kandidaten.',
  wizListForecastSplit:
    'Analyse läuft: {{today}} Kandidaten heute (noch ca. {{minutes}}), die restlichen {{rest}} ab {{date}}.',
  wizListForecastSplitNoDate:
    'Analyse läuft: {{today}} Kandidaten heute (noch ca. {{minutes}}), die restlichen {{rest}} an den folgenden Arbeitstagen.',
  wizListForecastRest:
    'Heute sind keine weiteren Analysen möglich. Die restlichen {{rest}} Kandidaten analysiert SAIA ab {{date}}.',
  wizListForecastRestNoDate:
    'Heute sind keine weiteren Analysen möglich. Die restlichen {{rest}} Kandidaten analysiert SAIA an den folgenden Arbeitstagen.',
  wizListRecommend:
    'Die Suche läuft. Du musst nicht warten: Richte die Kampagne in der Zwischenzeit weiter ein. SAIA meldet sich per E-Mail, sobald die Profile dieses Suchlaufs analysiert sind, damit du sie prüfen und freigeben kannst.',
  wizListForecastContinue: 'Weiter',
  wizListLimitTitle: 'Analyse für heute abgeschlossen',
  wizListLimitBody:
    'Da wir laut deinen Grundeinstellungen maximal {{limit}} Profilbesuche pro Tag durchführen, melden wir uns, wenn die Analyse für diesen Durchlauf abgeschlossen ist – und jedes Mal, wenn neue Analysen zur Verfügung stehen, damit du die Kandidaten prüfen kannst.',
  wizListLimitOk: 'Verstanden',
  wizDrawerTitle: 'Talent-Vorschau',
  wizDrawerClose: 'Schließen',
  wizDrawerPrev: 'Vorheriger Kandidat',
  wizDrawerNext: 'Nächster Kandidat',
  wizDrawerYears: '{{location}} · {{years}} Jahre Erfahrung',
  wizDrawerAt: '{{title}} bei {{company}}',
  wizDrawerChangeJudgement: 'Einstufung ändern',
  wizDrawerManual: 'manuell angepasst · ',
  wizDrawerOrigJudge: 'KI-Urteil: {{label}}',
  wizDrawerBlockedPerson: 'Kandidat steht auf: {{lists}}',
  wizDrawerBlockedCompany: '{{company}} steht auf: {{lists}}',
  wizDrawerExclude: 'Von der Kontaktliste ausschließen',
  wizDrawerInclude: 'Zur Kontaktliste hinzufügen',
  wizDrawerPersonAdd: 'Kandidat zur Blacklist …',
  wizDrawerPersonRemove: 'Kandidat von Blacklist entfernen',
  wizDrawerCompanyAdd: '{{company}} zur Blacklist …',
  wizDrawerCompanyRemove: '{{company}} von Blacklist entfernen',
  wizDrawerAddTo: '{{name}} hinzufügen zu …',
  wizDrawerTargetCampaign: 'Nur diese Kampagne',
  wizDrawerTargetCampaignMeta: 'Kampagnen-Blacklist',
  wizDrawerTargetGlobalCompanies: 'Global · {{amount}} Firmen',
  wizDrawerTargetGlobalContacts: 'Global · {{amount}} Kontakte',
  wizDrawerTargetOff: ' · für diese Kampagne aus',
  wizDrawerTabOverview: 'Kandidaten-Bewertungsübersicht',
  wizDrawerTabCandidate: 'Über Kandidat',
  wizDrawerTabCompany: 'Über Unternehmen',
  wizDrawerAssessment: 'KI-Einschätzung',
  wizDrawerPsychology: 'Psychologisches Profil',
  wizDrawerPsychologyHint: 'KI-Analyse des Profils',
  wizDrawerPersonality: 'Persönlichkeitstyp',
  wizDrawerPersonaTabType: 'Persönlichkeitstyp',
  wizDrawerPersonaTabDos: 'Do\u0027s',
  wizDrawerPersonaTabDonts: 'Don\u0027ts',
  wizDrawerPersonaTabBoosters: 'Booster Worte',
  wizDrawerMotives: 'Motive',
  wizDrawerMotiveTop: 'Beziehung',
  wizDrawerMotiveRight: 'Einfluss',
  wizDrawerMotiveBottom: 'Risiko',
  wizDrawerMotiveLeft: 'Leistung',
  wizDrawerStyle: 'Sprachstil',
  wizDrawerStyleFormal: 'formell',
  wizDrawerStyleInformal: 'informell',
  wizDrawerAccTraits: 'Eigenschaften von {{name}}',
  wizDrawerAccDefines: 'Das definiert {{name}}',
  wizDrawerAccImportant: 'Das ist {{name}} wichtig',
  wizDrawerAccQuestions: 'Beantworte {{name}} folgende Fragen',
  wizDrawerPersonaHint: 'Fließt automatisch in Ton und Wortwahl der Nachrichten an {{name}} ein.',
  wizDrawerNoPersona: 'Für diesen Kandidaten liegt noch keine Analyse des Persönlichkeitstyps vor.',
  wizDrawerSkillMatch: 'Skills im Abgleich mit deinen Kriterien',
  wizDrawerGroupMust: 'Muss',
  wizDrawerGroupNice: 'Wünschenswert',
  wizDrawerGroupExcl: 'Ausschluss',
  wizDrawerAnalysed: 'Analysiert von SAIA anhand des LinkedIn-Profils',
  wizDrawerExperience: 'Berufserfahrung',
  wizDrawerSkills: 'Skills',
  wizDrawerCompanyName: 'Unternehmen',
  wizDrawerIndustry: 'Branche',
  wizDrawerSize: 'Größe',
  wizDrawerSizeValue: '{{size}} Mitarbeitende',
  wizDrawerLocation: 'Standort',
  wizDrawerLoading: 'Details werden geladen …',
  wizDrawerLoadError: 'Die Details konnten nicht geladen werden.',
  wizListSearchFailed:
    'LinkedIn hat für diese Suche keine Treffer geliefert. Prüfe Jobtitel und Orte in Schritt 2.',
  wizListSearchFailedReason: 'Die Suche ist fehlgeschlagen: {{reason}}',
  wizListRestartSearch: 'Suche erneut starten',
  wizListStartSearch: 'Suche starten',
  wizListRestartBusy: 'Suche wird gestartet …',
  wizListRestartError: 'Die Suche konnte nicht gestartet werden.',
  wizListNoCandidates: 'Keine Kandidaten gefunden',
  wizListNotStarted: 'Die Suche wurde noch nicht gestartet.',
  wizListSearchPlaceholder: 'Name, Jobtitel, Firma oder Ort suchen',
  wizListFilterClassLabel: 'Klasse:',
  wizListFilterStatusLabel: 'Status:',
  wizListFilterLocationAll: 'Alle Orte',
  wizListFilterCompanyAll: 'Alle Firmen',
  wizListFilterCount: '{{shown}} von {{total}} Kandidaten',
  wizListFilterReset: 'Filter zurücksetzen',
  wizListStatusRated: 'Bewertet',
  wizListStatusAnalysing: 'Wird analysiert / bewertet',
  wizListStatusQuota: 'Wartet auf Kontingent',
  wizListStatusFailed: 'Fehlgeschlagen',
  wizListStatusExcluded: 'Blacklist / nicht passend',
  wizListSelectAll: 'Alle auswählen',
  wizListSelectRow: 'Kandidat auswählen',
  wizListSelected: '{{count}} ausgewählt',
  wizListBulkRejudge: 'Neu bewerten',
  wizListBulkBlacklistPeople: 'Personen auf Kampagnen-Blacklist',
  wizListBulkBlacklistCompanies: 'Firmen auf Kampagnen-Blacklist',
  wizListBulkExport: 'Exportieren (CSV)',
  wizListBulkConfirmBlacklist:
    '{{count}} Kandidaten auf die Kampagnen-Blacklist setzen? Sie werden nicht angesprochen.',
  wizListBulkDone: '{{done}} von {{total}} erledigt.',
  wizDrawerCriteria: 'Kriterien dieser Kampagne',
  wizDrawerCriteriaNote:
    'Die KI vergibt eine Klasse mit Begründung, keine Einzelbewertung je Kriterium.',
};
export default wizCandidatesListDE;
